import toast from "react-hot-toast";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import {
  findObjectUseCase,
  updateObjectUseCase,
} from "../../../../usecases/object";
import { v4 as uuidv4 } from "uuid";

export default class NegativeRecordsViewPresenter extends BaseFormPresenter {
  componentDidMount() {
    this.init();
    this.getAffialiateOutSide();
    this.getAccessRequest();
    this.getUser();
    this.getObject();
  }

  async getAffialiateOutSide() {
    const collection = "affiliates";
    const query = {
      where: {
        group: "OUTSIDE",
        isShowOutSide: true,
      },
    };

    try {
      const response = await findObjectUseCase().execute(collection, query);
      this.view.setOutSideClient(response);
    } catch (error) {}
  }

  async getAccessRequest() {
    const { id: userID } = this.view.getCurrentUser();
    const id = this.object.id || this.view.getObjectId();

    try {
      const [request] = await findObjectUseCase().execute("access_request", {
        where: {
          record_requested: { id },
          requestor: { id: userID },
          status: "Request for Access",
        },
      });

      this.view.setAccessRequestObject(request);
    } catch (error) {
      this.view.showError(error);
    }
  }

  async getUser() {
    const user = this.view.getCurrentUser();
    const collection = "users";
    const query = {
      where: {
        id: user.id,
      },
      include: ["affiliate", "branch"],
    };

    try {
      const response = await findObjectUseCase().execute(collection, query);
      this.view.setUser(response);
    } catch (error) {}
  }

  onRequestAccessChange(value, field) {
    const object = this.view.state.requestAccessObject;
    object[field] = value;
    this.view.setRequestAccessObject(object);
  }

  async getObject() {
    const id = this.object.id || this.view.getObjectId();
    if (!id) return;

    const collection = this.view.getCollectionName();
    const currentUser = this.view.getCurrentUser();
    const query = {
      where: { id },
      include: ["lockedTo.affiliate", "lockedTo.branch"],
    };

    try {
      this.view.showProgress();

      // Fetch record from "records" or fallback to "no_records"
      let results = await findObjectUseCase().execute("records", query);
      if (!results?.length) {
        results = await findObjectUseCase().execute("no_records", query);
      }

      this.object = results?.[0];
      if (!this.object) {
        this.view.hideProgress();
        return;
      }

      // Handle locking logic for records without "lockedTo"
      if (!this.object.lockedTo && !this.object.company) {
        await this.handleRecordLocking(collection, currentUser);
      }

      this.view.setObject(this.object);

      // Fetch related data in parallel for non-company records
      if (!this.object.company) {
        await this.fetchRelatedData();
      }

      // Fetch user affiliate/branch data
      const getUserAffBranch = await findObjectUseCase().execute("users", {
        where: { id: currentUser.id },
        include: ["all"],
      });
      this.view.setUserAffBranch(getUserAffBranch);

      this.view.hideProgress();
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }

  async handleRecordLocking(collection, currentUser) {
    const { firstName, middleName, lastName, alias } = this.object;
    const outside = this.view.state.outSideClient || [];
    const outsideNames = new Set(outside.map((out) => out.name));

    // Fetch cases and user data in parallel
    const [cases, userResult] = await Promise.all([
      findObjectUseCase().execute(collection, {
        where: { firstName, middleName, lastName, alias },
        keys: ["id"],
      }),
      findObjectUseCase().execute("users", {
        where: { id: currentUser.id },
        include: ["all"],
        keys: ["affiliate"],
      }),
    ]);

    const userName = userResult?.[0]?.affiliate?.name;
    const isFinance = outsideNames.has(userName);

    if (!isFinance && cases?.length) {
      const now = new Date().toISOString();

      const results = await Promise.all(
        cases.map((item) => {
          const updateData = {
            id: item.id,
            lockedTo: { id: currentUser?.id },
            lockedDate: now,
            specificDateLocked: now,
            searchNameId: uuidv4(), // Bagong UUID
          };

          return updateObjectUseCase().execute(collection, updateData, {});
        }),
      );

      console.log("Update results:", results);
      this.view.reload();
    }

    this.object.lockedTo = currentUser;
  }

  // async fetchRelatedData() {
  //   const { noRecord, firstName, middleName, lastName, alias, searchNameId } =
  //     this.object;
  //   const affiliateID = this.object?.lockedTo?.affiliate?.id;
  //   // console.log("1do", searchNameId);
  //   // Build parallel requests
  //   const requests = [
  //     // Contact persons
  //     findObjectUseCase().execute("users", {
  //       where: { affiliate: { id: affiliateID } },
  //     }),
  //     // Access history
  //     findObjectUseCase().execute("access_history", {
  //       where: { record: { id: searchNameId } },
  //       limit: 100,
  //       sort: { createdAt: -1 },
  //       include: ["accessor.affiliate", "accessor.branch"],
  //     }),
  //   ];

  //   // Add court cases request if not a noRecord
  //   if (!noRecord) {
  //     requests.push(
  //       findObjectUseCase().execute("records", {
  //         where: { firstName, middleName, lastName, alias },
  //       }),
  //     );
  //   }

  //   const [contacts, accessHistory, cases] = await Promise.all(requests);

  //   this.view.setContactPersons(contacts || []);
  //   this.view.setAccessHistory(accessHistory || []);
  //   this.view.setCourtCases(noRecord ? [] : cases || []);
  // }
  async fetchRelatedData() {
    const { noRecord, firstName, middleName, lastName, alias, searchNameId } =
      this.object;
    const affiliateID = this.object?.lockedTo?.affiliate?.id;
    // Build parallel requests
    const requests = [
      // Contact persons
      findObjectUseCase().execute("users", {
        where: { affiliate: { id: affiliateID } },
      }),
      // Access history
      findObjectUseCase().execute("access_history", {
        where: { record: { id: searchNameId } },
        limit: 100,
        sort: { createdAt: -1 },
        include: ["accessor.affiliate", "accessor.branch"],
      }),
    ];
    // Add court cases request if not a noRecord
    if (!noRecord) {
      requests.push(
        findObjectUseCase().execute("records", {
          where: { firstName, middleName, lastName, alias },
        }),
      );
    }
    const [contacts, accessHistory, cases] = await Promise.all(requests);
    // ---- resolve lockStatus for each access_history row ----
    const accessHistoryWithLockStatus = await this.attachLockStatus(
      accessHistory || [],
    );
    this.view.setContactPersons(contacts || []);
    this.view.setAccessHistory(accessHistoryWithLockStatus);
    this.view.setCourtCases(noRecord ? [] : cases || []);
  }

  async attachLockStatus(accessHistory) {
    if (!accessHistory.length) return [];

    // 1. Collect unique record ids referenced in access_history
    //    (these are actually `searchNameId` values, not `_id`)
    const recordIds = [
      ...new Set(accessHistory.map((h) => h.record?.id).filter(Boolean)),
    ];

    // 2. Look them up in no_record first
    const noRecordMatches = await findObjectUseCase().execute("no_records", {
      where: { searchNameId: { $in: recordIds } },
    });

    const foundInNoRecord = new Set(
      (noRecordMatches || []).map((r) => r.searchNameId),
    );

    // 3. Whatever wasn't found in no_record, look up in records
    const remainingIds = recordIds.filter((id) => !foundInNoRecord.has(id));

    const recordMatches = remainingIds.length
      ? await findObjectUseCase().execute("records", {
          where: { searchNameId: { $in: remainingIds } },
        })
      : [];

    // 4. Build a single lookup map: searchNameId -> { lockedDate, lockedToId }
    const lockInfoMap = new Map();
    [...(noRecordMatches || []), ...(recordMatches || [])].forEach((doc) => {
      lockInfoMap.set(doc.searchNameId, {
        lockedDate: doc.lockedDate?.$date || doc.lockedDate,
        lockedToId: doc.lockedTo?.id || null,
      });
    });

    // 5. Both conditions must match: createdAt date === lockedDate date
    //    AND accessor.id === lockedTo.id
    const toDateOnly = (d) => {
      if (!d) return null;
      const date = new Date(d);
      return date.toISOString().slice(0, 10); // "YYYY-MM-DD"
    };

    return accessHistory.map((h) => {
      const recordId = h.record?.id;
      const info = lockInfoMap.get(recordId);
      const createdAt = h.createdAt?.$date || h.createdAt;
      const accessorId = h.accessor?.id;

      const isSameDate =
        info?.lockedDate &&
        toDateOnly(info.lockedDate) === toDateOnly(createdAt);
      const isSameAccessor = info?.lockedToId && info.lockedToId === accessorId;

      return {
        ...h,
        lockStatus: isSameDate && isSameAccessor ? "Y" : "N",
        lockedTo: info?.lockedToId || null,
      };
    });
  }

  // async attachLockStatus(accessHistory) {
  //   if (!accessHistory.length) return [];

  //   // 1. Collect unique record ids referenced in access_history
  //   //    (these are actually `searchNameId` values, not `_id`)
  //   const recordIds = [
  //     ...new Set(accessHistory.map((h) => h.record?.id).filter(Boolean)),
  //   ];

  //   // 2. Look them up in no_record first
  //   const noRecordMatches = await findObjectUseCase().execute("no_record", {
  //     where: { searchNameId: { $in: recordIds } },
  //   });

  //   const foundInNoRecord = new Set(
  //     (noRecordMatches || []).map((r) => r.searchNameId),
  //   );

  //   // 3. Whatever wasn't found in no_record, look up in records
  //   const remainingIds = recordIds.filter((id) => !foundInNoRecord.has(id));

  //   const recordMatches = remainingIds.length
  //     ? await findObjectUseCase().execute("records", {
  //         where: { searchNameId: { $in: remainingIds } },
  //       })
  //     : [];

  //   // 4. Build a single lookup map: searchNameId -> { lockedDate, lockedToId }
  //   const lockInfoMap = new Map();
  //   [...(noRecordMatches || []), ...(recordMatches || [])].forEach((doc) => {
  //     lockInfoMap.set(doc.searchNameId, {
  //       lockedDate: doc.lockedDate?.$date || doc.lockedDate,
  //       lockedToId: doc.lockedTo?.id || null,
  //     });
  //   });

  //   // 5. Compare dates (date-only) AND accessor === lockedTo, tag lockStatus
  //   const toDateOnly = (d) => {
  //     if (!d) return null;
  //     const date = new Date(d);
  //     return date.toISOString().slice(0, 10); // "YYYY-MM-DD"
  //   };

  //   return accessHistory.map((h) => {
  //     const recordId = h.record?.id;
  //     const info = lockInfoMap.get(recordId);
  //     const createdAt = h.createdAt?.$date || h.createdAt;
  //     const accessorId = h.accessor?.id;

  //     const isSameDate =
  //       info?.lockedDate &&
  //       toDateOnly(info.lockedDate) === toDateOnly(createdAt);
  //     const isSameAccessor = info?.lockedToId && info.lockedToId === accessorId;

  //     return {
  //       ...h,
  //       lockStatus: isSameDate && isSameAccessor ? "Y" : "N",
  //       lockedTo: info?.lockedToId || null,
  //     };
  //   });
  // }

  // async attachLockStatus(accessHistory) {
  //   if (!accessHistory.length) return [];

  //   // 1. Collect unique record ids referenced in access_history
  //   //    (these are actually `searchNameId` values, not `_id`)
  //   const recordIds = [
  //     ...new Set(accessHistory.map((h) => h.record?.id).filter(Boolean)),
  //   ];

  //   // 2. Look them up in no_record first
  //   const noRecordMatches = await findObjectUseCase().execute("no_records", {
  //     where: { searchNameId: { $in: recordIds } },
  //   });

  //   const foundInNoRecord = new Set(
  //     (noRecordMatches || []).map((r) => r.searchNameId),
  //   );

  //   // 3. Whatever wasn't found in no_record, look up in records
  //   const remainingIds = recordIds.filter((id) => !foundInNoRecord.has(id));

  //   const recordMatches = remainingIds.length
  //     ? await findObjectUseCase().execute("records", {
  //         where: { searchNameId: { $in: remainingIds } },
  //       })
  //     : [];

  //   // 4. Build a single lookup map: searchNameId -> lockedDate
  //   const lockedDateMap = new Map();
  //   [...(noRecordMatches || []), ...(recordMatches || [])].forEach((doc) => {
  //     lockedDateMap.set(
  //       doc.searchNameId,
  //       doc.lockedDate?.$date || doc.lockedDate,
  //     );
  //   });

  //   // 5. Compare dates (date-only, ignoring time) and tag lockStatus
  //   const toDateOnly = (d) => {
  //     if (!d) return null;
  //     const date = new Date(d);
  //     return date.toISOString().slice(0, 10); // "YYYY-MM-DD"
  //   };

  //   return accessHistory.map((h) => {
  //     const recordId = h.record?.id;
  //     const lockedDate = lockedDateMap.get(recordId);
  //     const createdAt = h.createdAt?.$date || h.createdAt;

  //     const isSameDate =
  //       lockedDate && toDateOnly(lockedDate) === toDateOnly(createdAt);

  //     return {
  //       ...h,
  //       lockStatus: isSameDate ? "Y" : "N",
  //     };
  //   });
  // }

  async submitRequest() {
    try {
      this.view.showProgress();
      const currentUser = this.view.getCurrentUser();
      const { object, requestAccessObject } = this.view.state;

      // GET LAST REQUEST NUMBER
      const [request] = await findObjectUseCase().execute("access_request", {
        limit: 1,
        sort: { createdAt: -1 },
      });

      const data = {
        ...requestAccessObject,
        record_requested: object,
        requestor: currentUser,
        request_number: (request?.request_number || 0) + 1,
      };

      const prev = data?.record_requested;

      data.record_requested = { id: data.record_requested?.id };
      data.no_record_requested = { id: data.record_requested?.id };
      data.prev_record_requested = { prev };
      data.requestor = { id: data.requestor?.id };
      data.approverName = object?.lockedTo?.id;
      data.requestedDate = new Date().toISOString();

      if (object?.noRecord) {
        data.no_record = true;
      }

      await this.upsertUseCase.execute("access_request", data);
      this.getAccessRequest();
      toast.success("Request Submitted!", { position: "top-right" });
      this.view.hideProgress();
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }
}
